module.exports = __webpack_public_path__ + "static/og-image-twitter-6c67597c4f749c7013d2226d5e539ffa.png";